export enum AppointmentGuideActionKeys {
  FetchAppointmentGuideList = 'fetchAppointmentGuideList',
}

export type GetGuideApiLegacyResponse = PaginateGuideListParams & {
  results: ResultApiLegacy[];
};

export interface AppointmentGuideDTO {
  id: string;
  appointmentDate: string;
  billedIn: string;
  completed: boolean;
  insuranceName: string;
  patientName: string;
  version: string;
  api: 'microservice' | 'legacy';
}

export interface FetchGuideApiLegacyRequestParams {
  limit: number;
  page?: number;
}

export interface PaginateGuideListParams {
  next: string | null;
  previous: string | null;
  count: number;
  pageCurrent: number;
  totalPages: number;
}

export interface ResultApiLegacy {
  id: number;
  clinic: number;
  event: number | null;
  physician: number;
  insurance: number;
  version: string;
  insurance_name: string;
  insurance_ans_number: string;
  provider_guide_number: string;
  operator_guide_number: number;
  card_number: string;
  card_expiration: string;
  newborn: boolean;
  patient_name: string;
  cns_number?: string;
  identifier: string;
  provider_code: string;
  provider_name: string;
  cnes: string;
  executant_name: string;
  council_name: string;
  council_number: string;
  council_state: string;
  cbo: string;
  accident: string;
  appointment_date: string;
  appointment_kind: string;
  table_code: string;
  procedure_code: string;
  procedure_price: string;
  observation: string;
  billed: boolean;
  completed: boolean;
  date_added: string;
  social_name: string;
  special_coverage: number;
  attendence_regimen: number;
  occupational_health: number;
  billed_in: string;
}

export interface ResultApiTissInvoicing {
  id: string;
  event_id: number;
  date?: string;
  patient: Patient;
  physician: Physician;
  total_amount: string;
  lot_id?: string;
  guide_number: string;
  quantity: number;
  lot_number?: number;
  billed_in?: string;
  insurance: Insurance;
  procedures_total_amount: number;
  expenses_total_amount: number;
}

export interface Patient {
  id: number;
  name: string;
  cns?: string;
  civil_name?: string;
}

export interface Physician {
  id: number;
  name: string;
  cnes: string;
}

export interface Insurance {
  id: number;
  name: string;
  ans_register: string;
  tiss_version?: string;
  provider_code: string | null;
  provider_code_type: string | null;
  provider?: string;
  clinic_provider_id?: number;
  uses_sadt_team: boolean;
}
